<template>
  <div class="container">
    <van-tabs
      v-model="active"
      color="#773E36"
      background="#f7f7f7"
      line-height="5"
      title-active-color="#773E36"
      title-inactive-color="#333"
      @change="onChangeTab"
    >
      <template v-for="item of tabs">
        <van-tab :key="item.id" :title="item.title">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onReachBottom"
          >
            <div class="list">
              <section v-if="type == 3">
                <div @click="wxsdk('bcbh')">
                  <van-image
                    width="100%"
                    radius="10"
                    :src="require('../../../assets/bcbhCover.png')"
                  />
                  <p class="van-ellipsis">北朝壁画专题数字展</p>
                </div>
              </section>
              <section v-if="type == 3">
                <div @click="wxsdk('jh')">
                  <van-image
                    width="100%"
                    radius="10"
                    :src="require('../../../assets/dhsxjh.png')"
                  />
                  <p class="van-ellipsis">大河上下 • 晋魂</p>
                </div>
              </section>
              <template v-for="item of list">
                <section :key="item.id" @click="goToDetail(item.externalLink)">
                  <van-image width="100%" radius="10" :src="item.coverImage" />
                  <p class="van-ellipsis">{{ item.title }}</p>
                </section>
              </template>
            </div>
          </van-list>
        </van-tab>
      </template>
    </van-tabs>
  </div>
</template>

<script>
import { getListByType, wxInfo } from "@/api/exhibit";
export default {
  name: "ExhibitList",
  data: () => ({
    active: 0,
    tabs: [
      { id: 0, title: "全景导览" },
      { id: 1, title: "电子书" },
      { id: 2, title: "数字展览应用" }
    ],
    list: [],
    loading: false,
    finished: false,
    pageNo: 0,
    type: 1,
    timer: null,
    openLink: ""
  }),
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  mounted() {
    // this.wxsdk();
  },
  methods: {
    // wxLaunch() {
    //   console.log("xxxxxxx");
    // },
    wxsdk(name) {
      // var links = "";
      // links = location.href.slice(location.href.indexOf('#')+1);
      // links = location.href;
      // links = "http://test8.chwhyun.com/";
      // wxInfo({ url: links, appName: "bcbh" }).then(res => {
      // console.log(1111, res);
      // wx.config({
      //   debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
      //   appId: res.result.appid, // 必填，公众号的唯一标识
      //   timestamp: res.result.timestamp, // 必填，生成签名的时间戳
      //   nonceStr: res.result.noncestr, // 必填，生成签名的随机串
      //   signature: res.result.signature, // 必填，签名
      //   jsApiList: [
      //     "checkJsApi", //判断当前客户端版本是否支持指定JS接口
      //     // 'updateAppMessageShareData', //分享朋友
      //     // 'updateTimelineShareData', //分享朋友圈
      //     "getLocation", //获取位置
      //     "openLocation", //打开位置
      //     // "scanQRCode", //扫一扫接口
      //     // 'chooseWXPay', //微信支付
      //     "chooseImage", //拍照或从手机相册中选图接口
      //     "previewImage" //预览图片接口
      //     // 'uploadImage', //上传图片
      //     // 'onMenuShareWeibo',
      //     // 'onMenuShareQZone',
      //     // 'startRecord',
      //     // 'stopRecord',
      //     // 'onVoiceRecordEnd',
      //     // 'playVoice',
      //     // 'pauseVoice',
      //     // 'stopVoice',
      //     // 'onVoicePlayEnd',
      //     // 'uploadVoice',
      //     // 'downloadVoice',
      //     // 'downloadImage',
      //     // 'translateVoice',
      //     // 'getNetworkType',
      //     // 'hideOptionMenu',
      //     // 'showOptionMenu',
      //     // 'hideMenuItems',
      //     // 'showMenuItems',
      //     // 'hideAllNonBaseMenuItem',
      //     // 'showAllNonBaseMenuItem',
      //     // 'closeWindow',
      //     // 'openProductSpecificView',
      //     // 'addCard',
      //     // 'chooseCard',
      //     // 'openCard',
      //   ], // 必填，需要使用的 JS 接口列表
      //   openTagList: ["wx-open-launch-weapp"] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      // });
      // wx.ready(() => {
      //   // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      //   wx.checkJsApi({
      //     jsApiList: ["openLocation"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      //     success: res => {
      //       console.log(2222, res);
      //       // 以键值对的形式返回，可用的api值true，不可用为false
      //       // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      //     }
      //   });
      //   // wx.getLocation({
      //   //   type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //   //   success: (res)=> {
      //   //     console.log(333,res);
      //   //   },
      //   // });
      // });
      // wx.error(res => {
      //   // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
      //   console.log("err", res);
      // });
      // });
      wxInfo({ appName: name }).then(res => {
        console.log("2222", res);
        this.openLink = res.result.openlink;
        location.href = this.openLink;
      });
    },
    async onReachBottom() {
      if (this.finished) return;
      this.loading = true;
      this.pageNo++;
      const { result } = await getListByType({
        pageNo: this.pageNo,
        type: this.type
      });
      console.log(result);
      if (this.list.length === result.total) {
        this.finished = true;
        return;
      }
      this.list = [...this.list, ...result.records];
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.finished = result.current === result.pages;
        this.loading = false;
      }, 100);
    },
    onChangeTab(name, title) {
      console.log(name, title, "切换");
      this.pageNo = 0;
      this.type = ++name;
      this.finished = false;
      this.list = [];
      this.onReachBottom();
    },
    goToDetail(link) {
      window.location.href = link;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f7f7f7;
  ::v-deep .van-tabs__line {
    bottom: 22px;
    z-index: 1;
  }
  .list {
    margin: 20px 15px;
    section {
      margin-bottom: 20px;
      font-size: 16px;
      color: #eaeaea;
      position: relative;
      // wx-open-launch-weapp{
      //   width: 100% !important;
      //   height: 100% !important;
      // }
      p {
        white-space: nowrap;
        margin: 0;
        position: absolute;
        bottom: 16px;
        left: 50%;
        font-weight: 600;
        transform: translateX(-50%);
        max-width: 100%;
      }
    }
  }
}
</style>
